module.exports = __webpack_public_path__ + "711e4bf8cc0b8ad21b60be435a97ed06.pdf";